<template>
  <div class="l-container ">
    <div class="step">
      <Step :currentStep="2" :steps="steps" />
    </div>
     <div class="title-top">
      お申し込み内容のご確認
    </div>
    <div class="lg:w-full" style="background: #E5E5E5;">
      <div class="l-container">

      </div>
      <div class="w-full pt-5">
        <div style="border: solid 1px #DCDEE0"> </div>
      </div>

      <div class="l-container sm:pt-8 mt-10">
        <div class="w-full h-52" style="background: #FFFFFF; border-radius: 10px;">
            <a-spin size="large" class="pt-36" tip="Loading...">
              <div class="spin-content">
              <!-- 我的描述文案是自定义的。。。 -->
              </div>
            </a-spin>
        </div>
      </div>
    </div>
    <div class="items-1 mt-5 mb-80">
      <div class="item">
        <a class="text-black" href="/">トップ</a>
        <i class="icon icon-bor-arrow-right px-5" />
      </div>
      <div class="item">
        <a class="text-black"  @click="gotoPath(1)">プラン詳細</a>
        <i class="icon icon-bor-arrow-right px-5" />
      </div>
      <div class="item">
        <a class="text-black"  @click="gotoPath(2)"> 申込</a>
        <i class="icon icon-bor-arrow-right px-5" />
      </div>
    </div>
    <div class="invisible pb-20">

    </div>
  </div>
</template>
<script>

import {
  Step
} from '@/components/compound'
import { CREATE_ORDER, UPDATE_ORDER } from '@/store/modules/plan/actions'
import _ from 'lodash'
export default {
  name: 'bs_10-001',
  components: {
    Step
  },
  data() {
    return {
      breadcrumb_data: ['トップ', 'メニュー名', '個人情報の第三者提供等に関するご同意について'],
      steps: [
        {
          id: 1,
          label: '申請内容を入力'
        },
        {
          id: 2,
          label: '申込確認'
        },
        {
          id: 3,
          label: '申込完了'
        }
      ]
    }
  },
  mounted() {
    const param = this.$route.query.param
    if(param) {
      this.completeOrder(this.$store.getters['order/get'].orderDetail)
    }
    console.log()
    console.log(_.get(this.$store.getters['order/get'], 'orderComplete', null))
  },
  methods: {
    completeOrder(data) {
      console.log(data)
      const totalCost = 'totalCost'
      const newData = Object.keys(data).reduce((object, key) => {
        if (key !== totalCost) {
          object[key] = data[key]
        }
        return object
      }, {})
      const query = this.$route.query
      const queryRegister = _.get(this.$store.getters['order/get'], 'orderComplete.query', null)
      newData.param = query.param
      if (data.acptNo) {
        this.$store.dispatch(UPDATE_ORDER, newData).then(
          () => {
            this.$toasted.success('オーダー更新が成功しました。')
            this.$router.push({path: '/register-complete', query: queryRegister})
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
      } else {
        this.$store.dispatch(CREATE_ORDER, newData).then(
          (result) => {
            console.log(result)
            if (result && result.acptNo) {
              newData.acptNo = result.acptNo
              newData.acptDtlNo = result.acptDtlNo
              newData.transactionId = result.transactionId
            }
            this.$toasted.success('オーダー作成が成功しました。')
            this.$router.push({path: '/register-complete', query: queryRegister})
            this.$store.commit('order/setOrder', newData)
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
      }
    }
  }
}
</script>

<style scoped>
@import "./styles.scss";
</style>